module.exports = __webpack_public_path__ + "static/media/law_in_hand_4.c4cf37d9.jpg";